import React from "react"
import TimeRegister from "../../views/timeRegister/TimeRegister.view"
import { AppRoutes } from "../../consts/appRoutes.consts"
import { VACATION_PERIOD_NAVIGATOR_MODES } from "../../consts/modules/vacations.consts"
import Clients from "../../views/clients/Clients.view"
import Home from "../../views/home/Home.view"
import ChangeLog from "../../views/changeLog/ChangeLog.view"
import GeneralReport from "../../views/generalReport/GeneralReport.view"
import IndividualReport from "../../views/individualReport/IndividualReport.view"
import ClientBudget from "../../views/clientBudget/ClientBudget.view"
import PendingTasks from "../../views/pendingTasks/PendingTasks.view"
import Client from "../../views/clients/Client.view"
import ProjectForm from "../../views/clients/ProjectForm.view"
import Vacations from "../../views/vacations/Vacations.view"
import ClientReport from "../../views/clientReport/ClientReport.view"

export const TEAM_LEADER_ROUTES = [
  {
    path: AppRoutes.home.index,
    element: <Home />,
  },
  {
    path: AppRoutes.registroTiempos.index,
    element: <TimeRegister />,
  },
  {
    path: AppRoutes.clientes.index,
    element: <Clients />,
  },
  {
    path: AppRoutes.clientes.presupuestoCliente,
    element: <ClientBudget />,
  },
  {
    path: AppRoutes.reporteGeneral.index,
    element: <GeneralReport />,
  },
  {
    path: AppRoutes.reporteGeneral.horasSemana,
    element: <GeneralReport />,
  },
  {
    path: AppRoutes.reporteGeneral.horasProyecto,
    element: <GeneralReport />,
  },
  {
    path: AppRoutes.reporteGeneral.horasEquipo,
    element: <GeneralReport />,
  },
  {
    path: AppRoutes.reporteGeneral.horasCliente,
    element: <GeneralReport />,
  },
  {
    path: AppRoutes.reporteGeneral.consumosEquipo,
    element: <GeneralReport />,
  },
  {
    path: AppRoutes.reporteIndividual.index,
    element: <IndividualReport />,
  },
  {
    path: AppRoutes.reporteIndividual.redirect,
    element: <IndividualReport />,
  },
  {
    path: AppRoutes.changeLog.index,
    element: <ChangeLog />,
  },
  {
    path: AppRoutes.listaPendientes.index,
    element: <PendingTasks />,
  },
  {
    path: AppRoutes.clientes.detalles,
    element: <Client />,
  },
  {
    path: AppRoutes.clientes.crearProyecto,
    element: <ProjectForm />,
  },
  {
    path: AppRoutes.clientes.editarProyecto,
    element: <ProjectForm />,
  },
  {
    path: AppRoutes.vacaciones.index,
    element: <Vacations mode={VACATION_PERIOD_NAVIGATOR_MODES.PERIOD} />,
  },
  {
    path: AppRoutes.vacaciones.historialVacacionesMiembroEquipo,
    element: (
      <Vacations mode={VACATION_PERIOD_NAVIGATOR_MODES.HISTORY_TEAM_MEMBER} />
    ),
  },
  {
    path: AppRoutes.reporteCliente.index,
    element: <ClientReport />,
  },
  {
    path: AppRoutes.reporteCliente.desarrollo,
    element: <ClientReport />,
  },
  {
    path: AppRoutes.reporteCliente.consumo,
    element: <ClientReport />,
  },
  {
    path: AppRoutes.reporteCliente.burnchart,
    element: <ClientReport />,
  },
  {
    path: AppRoutes.reporteCliente.historicoSprints,
    element: <ClientReport />,
  },
  {
    path: AppRoutes.reporteCliente.tareas,
    element: <ClientReport />,
  },
  {
    path: AppRoutes.reporteCliente.descargaReporte,
    element: <ClientReport />,
  },
]
